<ion-row>
  <ion-col class="ion-text-center">
    <ion-searchbar id="searchBar" [placeholder]="this.translate.instant('029')" show-clear-button="focus" (keydown.enter)="ricerca()" mode="md" [(ngModel)]="searchQuery"></ion-searchbar>
  </ion-col>
</ion-row>

